﻿import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useUpdateRoleModules = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addOrUpdateRoleModule, { loading, data }] = useMutation<any>(
    mutations.updateRoleModules,
    {
      onCompleted: (response) => {
        if (response.addOrUpdateRoleModule?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    addOrUpdateRoleModule,
    loading,
    success,
    data,
    resetForm,
  };
};
